import ApplicationController from "./application_controller.js";
let mapCategoryURL = new Map();
export default class extends ApplicationController {
  static values = {
    documentId: String,
    baseUrl: String,
    categoryName: String,
    securityId: String,
    codeType: String,
  };

  connect() {
    this.render();
  }

  render() {
    this.element.innerHTML =
      `<div id="doccat${this.documentIdValue}" class="btn-group">` +
      `<button id="doccatitem${this.documentIdValue}" data-action="click->category-dropdown#getDocumentcategories" class="btn btn-link dropdown-toggle " style="margin: 0px;" data-toggle="dropdown" aria-expanded="false"> ${this.categoryNameValue} <i class="fa fa-caret-down"></i><span class="sr-only">Toggle dropdown</span></button>` +
      `<ul id="uldoccatitem${this.documentIdValue}" class="dropdown-menu" role="menu" aria-labelledby="doccatitem${this.documentIdValue}">` +
      `<li><a role="menuitem" href="javascript:void(0);" data-action="click->category-dropdown#updateDocumentCategory" tabindex="0">${this.categoryNameValue}</a></li>` +
      "</ul>" +
      '<script type="text/javascript">' +
      `//<![CDATA[document.getElementById("uldoccatitem${this.documentIdValue}").addEventListener("mouseenter", function(event) {scheduleResizeFrame("managecase");}, false);//]]>` +
      "</script>" +
      "</div>";
  }

  updateDocumentCategory(ev) {
    let documentCategoryDisplay = document.getElementById(
      `doccatitem${this.documentIdValue}`,
    );
    let categoryName = ev.currentTarget.innerHTML;
    let categoryUpdateURL = mapCategoryURL.get(categoryName);
    if (categoryUpdateURL != null) {
      fetch(categoryUpdateURL).then((response) =>
        console.log("STATUS: " + response.status),
      );
    }

    documentCategoryDisplay.innerHTML = `${categoryName} <i class="fa fa-caret-down"></i><span class="sr-only">Toggle dropdown</span>`;
  }

  getDocumentcategories() {
    //getting the url and the authId from constants in Query.java
    const baseUrl =
      `${this.baseUrlValue}internal/category/${this.documentIdValue}`.replace(
        "/servlet",
        "",
      );
    const listToUpdate = document.getElementById(
      `uldoccatitem${this.documentIdValue}`,
    );

    this.removeListItems(listToUpdate);
    fetch(`${baseUrl}`, {
      method: "POST",
      headers: {
        "Content-Type": "application/x-www-form-urlencoded",
      },
      body: new URLSearchParams(
        `authId=${this.securityIdValue}&customerCode=${this.codeTypeValue}`,
      ),
    })
      .then((response) => response.json())
      .then((data) => {
        data.forEach((category) => {
          mapCategoryURL.set(category.categoryName, category.url);
          this.addListItems(listToUpdate, category.categoryName);
        });
      });
  }

  addListItems(target, categoryName) {
    const ul = target;
    let li = document.createElement("li");
    li.innerHTML = `<a href="javascript:void(0);" data-action="click->category-dropdown#updateDocumentCategory" tabindex="0">${categoryName}</a>`;
    ul.appendChild(li);
  }

  removeListItems(target) {
    let ul = target;
    let delChild = ul.lastChild;
    while (delChild) {
      ul.removeChild(delChild);
      delChild = ul.lastChild;
    }
  }
}
